import {Component, Input} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {Lookups, Race} from "@model";

@Component({
  selector: 'app-races-header',
  templateUrl: './races-header.component.html',
  styleUrls: ['./races-header.component.scss']
})
export class RacesHeaderComponent {
  @Input() race: Race | undefined;
  @Input() showExportButton: boolean = false;
  @Input() showName: boolean = false;
  @Input() languages: Lookups[] = [];
  @Input() defaultLanguage: number | undefined;
  @Input() cssClass: "small" | undefined
  @Input() isAdmin: boolean = false;

  constructor(public translocoService: TranslocoService) {
  }
}
